import { render } from "./TheReviews.vue?vue&type=template&id=a39f95ac&scoped=true"
import script from "./TheReviews.vue?vue&type=script&lang=js"
export * from "./TheReviews.vue?vue&type=script&lang=js"

import "./TheReviews.vue?vue&type=style&index=0&id=a39f95ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a39f95ac"]])

export default __exports__